export enum ESE_ENUM {
  QUESTION_NUMBER = 'Question Number',
  FUNCTION = 'Function',
  CATEGORY = 'Category',
  SUB_CATEGORY = 'Sub Category',
  CONTROL_NAME = 'Control Name',
  CONTROL_LABEL = 'Control Label',
  QUESTION = 'Question',
  REMEDIATION_TASK = 'Remediation Task',
  SUPPLEMETED_GUIDE = 'Supplemented Guide',
  SEVERITY = 'Severity',
  MANDATORY_ARTIFACTS = 'Mandatory Artifacts',
  MANDATORY_COMMENTS = 'Mandatory Comments',
  TEMPLATE = 'Template',
  IS_SELECTED = 'isSelected',
  SHOW_NAME = 'showName',
  QUESTION_NUM = 'Question Num',
  TEMPLATE_FILE = 'Template File',
}

export enum ESE_MAP_KEYS {
  'Question Number' = 'questionId',
  'Function' = 'function',
  'Category' = 'category',
  'Sub Category' = 'subCategory',
  'Control Name' = 'controlName',
  'Control Label' = 'label',
  'Question' = 'questionTitle',
  'Remediation Task' = 'questionTodo',
  'Supplemented Guide' = 'description',
  'Severity' = 'impact',
  'Mandatory Artifacts' = 'suggestedArtifact',
  'Mandatory Comments' = 'requiredComments',
  'Template' = 'artifactTemplate',
}
export enum ESE_FRAMEWORK_KEYS {
  CUSTOM_RISK_FRAMEWORK = 'CUSTOM_RISK_FRAMEWORK',
}

export enum ESE_TEMPLATE_MODALS {
  ACKNOWLEDGEMENT = 'acknowledgement Modal',
  QUESTIONNAIRE = 'questionnaire Modal',
}
